import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { NECESSARY_COOKIES } from 'app/util/constants';

@Component({
    selector: 'cva-standalone-cookies-consent',
    standalone: true,
    imports: [CommonModule, MatButtonModule],
    templateUrl: './cookies-consent.component.html',
    styleUrl: './cookies-consent.component.scss',
})
export class CookiesConsentComponent implements OnInit {
    showCookieBar = true;
    showPopup = false;
    showNecessary = false;
    necessaryCookies = NECESSARY_COOKIES

    ngOnInit() {
        const cookieAcknowledged = localStorage.getItem('cookieAcknowledged');
        if (cookieAcknowledged === 'true') {
            this.showCookieBar = false;
        }
    }

    acknowledgeCookies() {
        localStorage.setItem('cookieAcknowledged', 'true');
        this.showCookieBar = false;
    }

    openPopup() {
        this.showPopup = true;
    }

    closePopup() {
        this.showPopup = false;
    }

    onOverlayClick(event: Event) {
        if (event.target === event.currentTarget) {
            this.closePopup();
        }
    }

    toggleNecessary() {
        this.showNecessary = !this.showNecessary;
    }

    trackByFn(index: number): number {
        return index;
    }
}
